import * as React from 'react';

const SvgChevronRight = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={24}
    fill="none"
    stroke="#56565b"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="chevron-right_svg__feather chevron-right_svg__feather-chevron-right"
    {...props}
  >
    <path d="M9 18l6-6-6-6" />
  </svg>
);

export default SvgChevronRight;
